/* 
 * listings filter js component
 */

import _Abstract from "system/abstract"
export default class Component_BackgroundImageRotator extends _Abstract {
  constructor(el, options) 
  {
    super(el, $.extend(true, 
    {
        duration:3500, //Milliseconds
        fadeTime:1500,//Milliseconds
        baseImagePath: "", //The folder the images live (useful if all of the images are in the same folder, saves on html markup),
        sameTimeFadeInOut:false // whether or not the previous image should fade out, if set to false, the next image to rotate in simply goes infront and fades in. otherwise both fade at the same time (if true)
    },options), 'component')

    if(typeof this.options.images === "undefined" || !this.options.images || !this.options.images.length)
    {
        console.log("No images available to be used in background image rotator");
        return;
    }

    this.$imageCtn1 = $(document.createElement("div"));
    this.$imageCtn2 = $(document.createElement("div"));

    this.$el.append(this.$imageCtn1);
    this.$el.append(this.$imageCtn2);

    this.imageSwapperTimer = null;

    this.imageIndex = -1;
    this.initialise();
  }

  initialise()
  {

      this.loadAndSwapNextImage();

  }

  clearTimer()
  {
      if(!this.imageSwapperTimer)
      {
          return;
      }

      window.clearTimeout(this.imageSwapperTimer);
      this.imageSwapperTimer = null;
  }

  resetTimer()
  {
    this.clearTimer();
    this.imageSwapperTimer = window.setTimeout(() => this.loadAndSwapNextImage(),this.options.duration);
  }

  loadAndSwapNextImage()
  {
      console.log("loadAndSwapNextImage");
      this.incrementImageIndex();
      var imageURL = this.getFullImageURLFromIndex(this.imageIndex);
      this.loadAndSwapImageFromURL(imageURL);
  }

  incrementImageIndex()
  {
      ++this.imageIndex;
      if(this.imageIndex >= this.options.images.length)
      {
          this.imageIndex = 0;
      }
  }

  getFullImageURLFromIndex(_index)
  {
      var image = this.options.images[_index];
      var imageSRC = this.options.baseImagePath + image;
      return imageSRC;    
  }



  loadAndSwapImageFromURL(_url)
  {
      var $elementWithCurrentShowingImage = null;
      var $elementToFadeIn = null;

      if(this.$imageCtn1.is(":visible"))
      {
          $elementWithCurrentShowingImage = this.$imageCtn1;
          $elementToFadeIn = this.$imageCtn2;
      }
      else
      {
          $elementWithCurrentShowingImage = this.$imageCtn2;
          $elementToFadeIn = this.$imageCtn1;
      }


    //   $elementToFadeIn.css("z-index","1");
    //   $elementWithCurrentShowingImage.css("z-index","0");

   

      $elementToFadeIn.next().after($elementToFadeIn);


      var context = this;
      $elementToFadeIn.data("responsive-image",_url);
      $("body").trigger("responsive-image", {"$responsiveImageTargets":$elementToFadeIn,"fromRotator":true,"onComplete": function()
      {

          if(context.options.sameTimeFadeInOut)
          {
              $elementWithCurrentShowingImage.fadeOut();
          }

          $elementToFadeIn.fadeIn(context.options.fadeTime,function()
          {
              $elementWithCurrentShowingImage.removeData("responsive-image");
              $elementWithCurrentShowingImage.css("background-image","");
              $elementWithCurrentShowingImage.hide();
              context.resetTimer();
          })
      }});


    //   console.log("loadAndSwapImageFromURL");
    //   console.log("load image url: " + _url);
    //   this.$el.data("responsive-image",_url);
    //   $("body").trigger("responsive-image", {"$responsiveImageTargets":this.$el,"fromRotator":true});
  }
  


}



/** WEBPACK FOOTER **
 ** ./components/background-image-rotator.js
 **/